import React, { useState } from 'react';
import { Form, Spin } from 'components/ds';
import { ButtonLarge, FooterDiv } from 'components/Css';
import PasswordStrengthChecker from 'modules/account/components/PasswordStrengthChecker/PasswordStrengthChecker';
import { PasswordInput } from './PasswordForm.styles';
import { isPasswordFormValid } from '../../constantes/passwordConstants';

interface PasswordFormProps {
  isLoading: boolean;
  buttonText: string;
  onSubmit: (values: any) => Promise<void>;
  captchaComponent?: React.ReactNode;
  disableSubmit?: boolean;
}

interface PasswordConfig {
  password: string;
  confirmPassword: string;
}

export const PasswordForm: React.FC<PasswordFormProps> = ({
                                                            isLoading,
                                                            buttonText,
                                                            onSubmit,
                                                            captchaComponent,
                                                            disableSubmit
                                                          }) => {
  const [form] = Form.useForm() as any;
  
  const [passwordConfig, setPasswordConfig] = useState<PasswordConfig>({
    password: '',
    confirmPassword: ''
  });
  
  const validatePassword = (value: string, type: string) => {
    setPasswordConfig({
      ...passwordConfig,
      [type]: value
    });
  };
  
  const submitForm = () => {
    form.submit();
  };
  
  const isButtonDisabled = !isPasswordFormValid(passwordConfig?.password, passwordConfig?.confirmPassword);
  
  return (
    <>
      <Form
        form={form}
        layout='vertical'
        onFinish={onSubmit}
      >
        <Form.Item
          name='newPassword'
          rules={[
            {required: true, message: 'Por favor, insira sua nova senha!'},
            {min: 6, message: 'A senha deve ter ao menos 6 caracteres!'}
          ]}
        >
          <PasswordInput
            placeholder='Nova senha'
            size='large'
            onChange={(e) => validatePassword(e.target.value, 'password')}
          />
        </Form.Item>
        
        <PasswordStrengthChecker password={passwordConfig?.password}/>
        
        <Form.Item
          name='confirmPassword'
          dependencies={['newPassword']}
          rules={[
            {required: true, message: 'Por favor, confirme sua nova senha!'},
            ({getFieldValue}) => ({
              validator(_, value) {
                if (!value || getFieldValue('newPassword') === value) {
                  return Promise.resolve();
                }
                
                return Promise.reject(new Error('As senhas não correspondem!'));
              }
            })
          ]}
        >
          <PasswordInput
            placeholder='Confirmar nova senha'
            size='large'
            onChange={(e) => validatePassword(e.target.value, 'confirmPassword')}/>
        </Form.Item>
        
        {captchaComponent}
      </Form>
      
      <FooterDiv>
        <ButtonLarge
          onClick={submitForm}
          loading={isLoading}
          disabled={disableSubmit || isLoading || isButtonDisabled}
        >
          {isLoading ? <Spin/> : buttonText}
        </ButtonLarge>
      </FooterDiv>
    </>
  );
};
